import { channel } from 'redux-saga';
import { fork, select, take, takeEvery, put, cancel, spawn } from 'redux-saga/effects';
import { subscribe, unsubscribe } from '@push-component/client';
import { LIVE_SCORE } from '@push-component/constants';
import { PUSH_SUBSCRIBE_OWNER } from '../../constants';
import { isEventInPlay } from '../../utils';
import { BYO_LIVE_SCORE_START_UPDATES, BYO_LIVE_SCORE_STOP_UPDATES } from '../constants';
import { updateLiveScore } from '../actions';
let updateTask;
export function* liveScoreUpdateSaga() {
    const eventId = yield select(state => state.slip.eventId);
    if (eventId) {
        updateTask = yield spawn(liveScoreSubscribeSaga, eventId);
    }
}
export function* liveScoreSubscribeSaga(eventId) {
    const liveScoreChannel = channel();
    subscribe({
        eventId,
        isInPlay: isEventInPlay(),
        // @ts-ignore
        // TODO: should be fixed in @push-component/types
        isSummary: false,
        owner: PUSH_SUBSCRIBE_OWNER,
        type: LIVE_SCORE,
        callback: liveScoreChannel.put,
    });
    while (true) {
        const liveScoreData = yield take(liveScoreChannel);
        yield put(updateLiveScore(liveScoreData));
    }
}
export function* liveScoreUnsubscribeSaga() {
    const eventId = yield select(state => state.slip.eventId);
    if (eventId) {
        unsubscribe({
            eventId,
            owner: PUSH_SUBSCRIBE_OWNER,
            type: LIVE_SCORE,
        });
    }
    if (updateTask && !updateTask.isCancelled()) {
        yield cancel(updateTask);
    }
}
export function* startLiveScoreUpdates() {
    yield takeEvery(BYO_LIVE_SCORE_START_UPDATES, liveScoreUpdateSaga);
}
export function* stopLiveScoreUpdates() {
    yield takeEvery(BYO_LIVE_SCORE_STOP_UPDATES, liveScoreUnsubscribeSaga);
}
const liveScoreSagas = [
    fork(startLiveScoreUpdates),
    fork(stopLiveScoreUpdates),
];
export default liveScoreSagas;
